export default "__VITE_ASSET__DtvoDpP6__"